<template>
    <div class="row">
        <div class="col-xl-8 col-lg-8 col-md-10 col-sm-10 mx-auto form p-1">
            <div v-if="payload" class="alert alert-success" role="alert">
                Дані успішно збережені!
            </div>
            <div v-if="error" class="alert alert-danger" role="alert">
                Помилка при збереженні даних
            </div>
            <div class="card">
                <div class="card-body">
                    <div class="form-group">
                        <label>
                            <strong>ID</strong>
                        </label>
                        <input
                            name="uid"
                            type="text"
                            v-model="model.uid"
                            class="form-control"
                            disabled
                        >
                    </div>
                    <div class="form-group">
                        <label>
                            <strong>Статус</strong>
                        </label>
                        <select class="form-control" v-model="model.status">
                            <option :value="null" disabled>-</option>
                            <option value="новый">новый</option>
                            <option value="в работе">в работе</option>
                            <option value="завершен">завершен</option>
                        </select>
                    </div>
                    <div class="form-group">
                        <label>
                            <strong>Тип тр-ра</strong>
                        </label>
                        <select class="form-control" v-model="model.trans_type">
                            <option :value="null" disabled>-</option>
                            <option value="масляный">масляный</option>
                            <option value="сухой">сухой</option>
                        </select>
                    </div>
                    <div class="form-group mt-2 mb-1">
                        <a :href="model.file" target="_blank" class="file">
                            {{ model.file }} <i class="pi pi-file"></i>
                        </a>
                    </div>
                    <div class="form-group">
                        <label>
                            <strong>Ответственный региональный менеджер</strong>
                        </label>
                        <input
                            name="manager"
                            type="text"
                            v-model="model.manager"
                            class="form-control"
                        >
                    </div>
                    <div class="form-group">
                        <label>
                            <strong>Коментар адміна</strong>
                        </label>
                        <textarea
                            name="name"
                            type="text"
                            v-model="model.admin_comment"
                            class="form-control"
                        ></textarea>
                    </div>
                    <div class="form-group">
                        <label>
                            <strong>Організація *</strong>
                        </label>
                        <input
                            name="org_name"
                            type="text"
                            v-model="model.org_name"
                            class="form-control"
                        >
                    </div>
                    <div class="form-group">
                        <label>
                            <strong>Контактна особа *</strong>
                        </label>
                        <input
                            name="name"
                            type="text"
                            v-model="model.name"
                            class="form-control"
                        >
                    </div>
                    <div class="form-group">
                        <label>
                            <strong>Номер телефону *</strong>
                        </label>
                        <input
                            name="name"
                            type="text"
                            v-model="model.phone"
                            class="form-control"
                        >
                    </div>
                    <div class="form-group">
                        <label>
                            <strong>Електронна пошта *</strong>
                        </label>
                        <input
                            name="name"
                            type="text"
                            v-model="model.email"
                            class="form-control"
                        >
                    </div>
                    <div class="form-group">
                        <label>
                            <strong>Найменування та адреса *</strong>
                        </label>
                        <input
                            name="name"
                            type="text"
                            v-model="model.address"
                            class="form-control"
                        >
                    </div>
                    <div class="form-group">
                        <label>
                            <strong>Потужність, кВА</strong>
                        </label>
                        <input
                            name="name"
                            type="text"
                            v-model="model.power"
                            class="form-control"
                        >
                    </div>
                    <div class="form-group">
                        <label>
                            <strong>Номінальна напруга ВН, кВ</strong>
                        </label>
                        <input
                            name="name"
                            type="text"
                            v-model="model.material_BH_KB"
                            class="form-control"
                        >
                    </div>
                    <div class="form-group">
                        <label>
                            <strong>Номінальна напруга НН, кВ</strong>
                        </label>
                        <input
                            name="name"
                            type="text"
                            v-model="model.material_HH_KB"
                            class="form-control"
                        >
                    </div>
                    <div class="form-group">
                        <label>
                            <strong>Серія</strong>
                        </label>
                        <input
                            name="name"
                            type="text"
                            v-model="model.series"
                            class="form-control"
                        >
                    </div>
                    <div class="form-group" v-if="model.trans_type == 'масляный'">
                        <label>
                            <strong>Тип</strong>
                        </label>
                        <input
                            name="name"
                            type="text"
                            v-model="model.type"
                            class="form-control"
                        >
                    </div>
                    <div class="form-group">
                        <label>
                            <strong>Призначення</strong>
                        </label>
                        <input
                            name="name"
                            type="text"
                            v-model="model.destination"
                            class="form-control"
                        >
                    </div>
                    <div class="form-group">
                        <label>
                            <strong>Схема та група з’єднання обмоток</strong>
                        </label>
                        <input
                            name="name"
                            type="text"
                            v-model="model.winding_scheme"
                            class="form-control"
                        >
                    </div>
                    <div class="form-group">
                        <label>
                            <strong>Спосіб і діапазон регулювання напруги</strong>
                        </label>
                        <input
                            name="name"
                            type="text"
                            v-model="model.voltage_method"
                            class="form-control"
                        >
                    </div>
                    <div class="form-group">
                        <label>
                            <strong>Матеріал обмотки ВН</strong>
                        </label>
                        <input
                            name="name"
                            type="text"
                            v-model="model.material_BH"
                            class="form-control"
                        >
                    </div>
                    <div class="form-group">
                        <label>
                            <strong>Матеріал обмотки НН</strong>
                        </label>
                        <input
                            name="name"
                            type="text"
                            v-model="model.material_HH"
                            class="form-control"
                        >
                    </div>
                    <div class="form-group">
                        <label>
                            <strong>Вид підключення НН</strong>
                        </label>
                        <input
                            name="name"
                            type="text"
                            v-model="model.type_HH"
                            class="form-control"
                        >
                    </div>
                    <div class="form-group">
                        <label>
                            <strong>Вид підключення ВН</strong>
                        </label>
                        <input
                            name="name"
                            type="text"
                            v-model="model.type_BH"
                            class="form-control"
                        >
                    </div>
                    <div class="form-group" v-if="model.trans_type == 'сухой'">
                        <label>
                            <strong>Спосіб підключення НН</strong>
                        </label>
                        <input
                            name="name"
                            type="text"
                            v-model="model.type_connect_HH"
                            class="form-control"
                        >
                    </div>
                    <div class="form-group" v-if="model.trans_type == 'сухой'">
                        <label>
                            <strong>Клас нагрівостійкості ізоляції</strong>
                        </label>
                        <input
                            name="name"
                            type="text"
                            v-model="model.heat_resistance_class"
                            class="form-control"
                        >
                    </div>
                    <div class="form-group">
                        <label>
                            <strong>Температура експлуатації, °C</strong>
                        </label>
                        <input
                            name="name"
                            type="text"
                            v-model="model.operating_temperature"
                            class="form-control"
                        >
                    </div>
                    <div class="form-group">
                        <label>
                            <strong>Кількість тр-в., шт. *</strong>
                        </label>
                        <input
                            name="name"
                            type="text"
                            v-model="model.count"
                            class="form-control"
                        >
                    </div>
                    <div class="form-group" v-if="model.trans_type == 'масляный'">
                        <label>
                            <strong>Система захисту (для герметичних трансформаторів)</strong>
                        </label>
                        <input
                            name="name"
                            type="text"
                            v-model="model.protection_system_sealed"
                            class="form-control"
                        >
                    </div>
                    <div class="form-group" v-if="model.trans_type == 'масляный'">
                        <label>
                            <strong>Система захисту (для трансформаторів з розширювальним баком)</strong>
                        </label>
                        <input
                            name="name"
                            type="text"
                            v-model="model.protection_system_tank"
                            class="form-control"
                        >
                    </div>
                    <div class="form-group" v-if="model.trans_type == 'сухой'">
                        <label>
                            <strong>Блок контролю температури</strong>
                        </label>
                        <input
                            name="name"
                            type="text"
                            v-model="model.temperature_control_unit"
                            class="form-control"
                        >
                    </div>
                    <div class="form-group" v-if="model.trans_type == 'сухой'">
                        <label>
                            <strong>Датчики температури</strong>
                        </label>
                        <input
                            name="name"
                            type="text"
                            v-model="model.temperature_sensors"
                            class="form-control"
                        >
                    </div>
                    <div class="form-group" v-if="model.trans_type == 'сухой'">
                        <label>
                            <strong>Захисний кожух</strong>
                        </label>
                        <input
                            name="name"
                            type="text"
                            v-model="model.protective_casing"
                            class="form-control"
                        >
                    </div>
                    <div class="form-group" v-if="model.trans_type == 'сухой'">
                        <label>
                            <strong>Вентилятори примусового охолодження</strong>
                        </label>
                        <input
                            name="name"
                            type="text"
                            v-model="model.forced_cooling_fans"
                            class="form-control"
                        >
                    </div>
                    <div class="form-group" v-if="model.trans_type == 'сухой'">
                        <label>
                            <strong>Блок керування обдувом VRT-200</strong>
                        </label>
                        <input
                            name="name"
                            type="text"
                            v-model="model.control_vrt20"
                            class="form-control"
                        >
                    </div>
                    <div class="form-group" v-if="model.trans_type == 'сухой'">
                        <label>
                            <strong>Антивібраційні опори (4 шт.)</strong>
                        </label>
                        <input
                            name="name"
                            type="text"
                            v-model="model.antivibration_support"
                            class="form-control"
                        >
                    </div>
                    <div class="form-group">
                        <label>
                            <strong>Екрани між первинною та вторинною обмотками</strong>
                        </label>
                        <input
                            name="name"
                            type="text"
                            v-model="model.screens_between_windings"
                            class="form-control"
                        >
                    </div>
                    <div class="form-group" v-if="model.trans_type == 'масляный'">
                        <label>
                            <strong>Тип виводів ВН</strong>
                        </label>
                        <input
                            name="name"
                            type="text"
                            v-model="model.terminal_type_BH"
                            class="form-control"
                        >
                    </div>
                    <div class="form-group">
                        <label>
                            <strong>Напруга короткого замикання, %</strong>
                        </label>
                        <input
                            name="name"
                            type="text"
                            v-model="model.voltage_short_circuit"
                            class="form-control"
                        >
                    </div>
                    <div class="form-group">
                        <label>
                            <strong>Номінальна частота, Гц</strong>
                        </label>
                        <input
                            name="name"
                            type="text"
                            v-model="model.nominal_frequency"
                            class="form-control"
                        >
                    </div>
                    <div class="form-group">
                        <label>
                            <strong>Струм холостого ходу, %</strong>
                        </label>
                        <input
                            name="name"
                            type="text"
                            v-model="model.idle_current"
                            class="form-control"
                        >
                    </div>
                    <div class="form-group">
                        <label>
                            <strong>Втрати тр-ра у режимі х.х., Вт</strong>
                        </label>
                        <input
                            name="name"
                            type="text"
                            v-model="model.losses_hh"
                            class="form-control"
                        >
                    </div>
                    <div class="form-group">
                        <label>
                            <strong>Втрати тр-ра у режимі к.з., Вт</strong>
                        </label>
                        <input
                            name="name"
                            type="text"
                            v-model="model.losses_kz"
                            class="form-control"
                        >
                    </div>
                    <div class="form-group">
                        <label>
                            <strong>Габаритні розміри Д*Ш*В, мм</strong>
                        </label>
                        <input
                            name="name"
                            type="text"
                            v-model="model.overall_dimensions"
                            class="form-control"
                        >
                    </div>
                    <div class="form-group">
                        <label>
                            <strong>Сейсмостійкість по шкалі MSK-64, балів</strong>
                        </label>
                        <input
                            name="name"
                            type="text"
                            v-model="model.seismic_resistance"
                            class="form-control"
                        >
                    </div>
                    <div class="form-group">
                        <label>
                            <strong>Додаткова інформація</strong>
                        </label>
                        <textarea
                            name="name"
                            type="text"
                            v-model="model.additional_information"
                            class="form-control"
                        ></textarea>
                    </div>
                </div>
            </div>
            <div class="text-right">
                <template v-if="model.id">
                    <delete-confirmation
                        :route-path="route('api.form.delete', {form: model.id})"
                        :redirect-path="route('form.list')"
                        :title="'Удаление'"
                        class="btn btn-danger mr-1 text-white"
                    >Удалить</delete-confirmation>
                </template>
                <button
                    type="submit"
                    class="btn btn-primary"
                    @click.prevent="update"
                >
                    Сохранить
                </button>
            </div>
        </div>
    </div>
</template>

<script>
import AppLayout from "../Layouts/AppLayout";
import DataTable from "primevue/datatable";
import Menubar from "primevue/menubar";
import Column from "primevue/column";
import Row from "primevue/row";
import ColumnGroup from "primevue/columngroup";
import Button from "primevue/button";
import InputText from "primevue/inputtext";
import InputNumber from "primevue/inputnumber";
import AutoComplete from "primevue/autocomplete";
import axios from "axios";
import DeleteConfirmation from '../mixins/components/delete.vue';
import "bootstrap/dist/css/bootstrap.min.css"

export default {
    props: {
        model: {
            type: Object,
            required: false,
        }
    },
    name: "Index",
    layout: AppLayout,
    components: {
        AppLayout,
        Menubar,
        DataTable,
        Column,
        Row,
        ColumnGroup,
        Button,
        InputText,
        InputNumber,
        AutoComplete,
        DeleteConfirmation,
    },
    data() {
        return {
            errors: {},
            payload: false,
            error: false,
        }
    },
    mounted() {
        console.log(this.model);
    },
    methods: {
        update() {
            this.payload = false;
            this.error = false;
            axios.post(this.route('api.form.update', {form: this.model.id}), this.model)
                .then((result) => {
                    this.payload = true;
                    window.scroll(0, 0);
                }).catch((error) => {
                    this.error = true;
                    window.scroll(0, 0);
                })
        }
    }
}
</script>

<style scoped>
.file .pi {
    font-size: 24px;
}
</style>